module.exports = __webpack_public_path__ + "img/graficahidrocarburos1.54783482.png";